export default "__VITE_ASSET__Dx$$zrpG__"